
import Layout from './components/Layout';

export default function App() {
  return (
      <Layout />
  );
}
